import React from "react";
import { Button, Columns, Field, Modal, Section } from "@allxsmith/bestax-bulma";
import useInput from "../../hooks/useInput";

export default function MultipleEditModal({
  open,
  setOpen,
  selected,
  saveSelected
}) {
  const [invoiceDate, invoiceDateInput, setInvoiceDate] = useInput({
    type: "date",
    label: "Invoice Date"
  });
  const [invoiceNumber, invoiceNumberInput, setInvoiceNumber] = useInput({
    type: "text",
    label: "Invoice Number"
  });
  const [invoiceAmount, invoiceAmountInput, setInvoiceAmount] = useInput({
    type: "number",
    label: "Invoice Amount",
    currency: true
  });

  const [invoiceVAT, invoiceVATInput, setInvoiceVAT] = useInput({
    type: "number",
    label: "Invoice VAT",
    currency: true
  });
  const [comments, commentsInput, setComments] = useInput({
    type: "text",
    label: "Comments"
  });

  const onSave = () => {
    saveSelected(invoiceDate, invoiceNumber, invoiceAmount, invoiceVAT, comments).then(onClose);
  };

  const onClose = () => {
    setOpen(false);
    setInvoiceNumber("");
    setInvoiceDate("");
    setInvoiceAmount("");
    setInvoiceVAT("");
    setComments("");
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal closeOnBlur active={open} onClose={onClose}>
      <Modal.Content>
        <Section style={{ backgroundColor: "white" }}>
          <Columns isMultiline>
            {invoiceNumberInput}
            {invoiceDateInput}
          </Columns>
          <Columns isMultiline>
            {invoiceAmountInput}
            {invoiceVATInput}
          </Columns>
          <Columns isMultiline>
            {commentsInput}
          </Columns>
          <Field>
            <p>You are editing {Object.keys(selected).length} parts</p>
          </Field>
          <Button color="success" onClick={onSave}>
            Save
          </Button>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
